import { useApi } from "../../hooks/useApi";
import { Brand } from "../../types/paymentProcessor";
import { BRAND_LABEL } from "../../constants/brand";
import CreatableSelect from "./CreatableSelect";

interface BrandSelectProps {
  brands: Brand[];
  value: number | "";
  onChange: (brandId: number) => void;
  refreshBrands: () => void;
  disabled?: boolean;
  createBrandUrl?: string;
}

export default function BrandSelect({
  brands,
  value,
  onChange,
  refreshBrands,
  disabled = false,
  createBrandUrl = '/api/pp-accounts/brands',
}: BrandSelectProps) {
  const { post } = useApi();

  const handleCreate = async (name: string) => {
    const newBrand = await post<Brand>(createBrandUrl, { name });
    refreshBrands();
    return String(newBrand.brandId);
  };

  return (
    <CreatableSelect
      label={BRAND_LABEL.singular}
      value={value === "" ? "" : String(value)}
      options={brands.map((brand) => ({ value: String(brand.brandId), label: brand.brandName }))}
      onChange={(brandId) => onChange(Number(brandId))}
      onCreate={handleCreate}
      addLabel={`Add New ${BRAND_LABEL.singular}`}
      createPlaceholder={`${BRAND_LABEL.singular} name`}
      createFailedMessage={`Failed to create ${BRAND_LABEL.singular.toLowerCase()}`}
      disabled={disabled}
      required
    />
  );
}
